import {
  appConfigSchema,
  appConfigUpdateSchema,
  type AppConfigUpdateRequest,
} from "@chotca/config";
import type { RequestContext } from "./http";
import { requestJson } from "./http";

export function createAppConfigResource(ctx: RequestContext) {
  return {
    /** Public app config (force-update + maintenance). No auth — safe pre-login. */
    get() {
      return requestJson(ctx, {
        method: "GET",
        path: "/app-config",
        dataSchema: appConfigSchema,
        auth: false,
      });
    },

    /** ADMIN: flip maintenance / set the force-update floor. Partial patch. */
    update(body: AppConfigUpdateRequest) {
      const payload = appConfigUpdateSchema.parse(body);
      return requestJson(ctx, {
        method: "PATCH",
        path: "/admin/app-config",
        body: payload,
        dataSchema: appConfigSchema,
        auth: true,
      });
    },
  };
}
